var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6289 15.333C18.9089 15.7346 17.0101 15.9583 15.0127 15.9583C7.27495 15.9574 1 12.61 1 8.47869C1 4.34734 7.27495 1 15.0127 1C22.7505 1 29.0245 4.34829 29.0245 8.47869C29.0245 8.86017 28.97 9.23688 28.8658 9.60498",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3517 19.2224C18.7071 19.5838 16.903 19.7855 15.0137 19.7855C7.27494 19.7846 1 16.4343 1 12.304",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3345 32.4083C40.186 35.0788 33.5735 32.4619 28.5654 26.5617C23.5612 20.6587 22.0553 13.7088 25.2038 11.0364C28.3551 8.3641 34.9656 10.9829 39.9737 16.885C44.9799 22.7841 46.4858 29.7351 43.3345 32.4083Z",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.974 11.2495L22.2874 13.5126C19.137 16.184 20.6419 23.1349 25.6481 29.037C30.6543 34.9381 37.2667 37.5549 40.4171 34.8836L43.5876 32.173",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6653 23.2065C19.6862 23.7764 17.4193 24.1005 15.0127 24.1005C7.27495 24.1005 1 20.7522 1 16.6208",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.895 26.7234C21.4789 27.7808 18.384 28.4166 15.0127 28.4166C7.27495 28.4166 1 25.0683 1 20.936",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0061 29.8896C23.4399 31.623 19.4682 32.7321 15.0127 32.7321C7.27495 32.7321 1 29.3838 1 25.2534",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2051 32.0964C26.2642 34.9839 21.0898 37.0472 15.0127 37.0472C7.27494 37.0472 1 33.7008 1 29.5675V9.18042",
    stroke: "#158F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.da655dbda85aa6a7180614d4f96bfc36.svg";
export { ForwardRef as ReactComponent };